// EditorialLetter, classic Vogue "Letter from the editor" band.
//
// An intimate first-person note in italic serif, with a real founder
// signature in script and a circular avatar slot. The avatar uses the
// founder's initials in gold until a real headshot lives at
// /public/founders/majula.jpg, at which point swap the `<span>` block
// for an `<img>` and the masthead reads as genuinely personal.
export function EditorialLetter() {
  return (
    <section
      className="bg-[#F9F6F0] paper-grain border-t border-stone-200 py-20 lg:py-28"
      data-testid="editorial-letter"
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <span className="overline">Letter</span>
        <h2 className="font-heading text-3xl sm:text-4xl tracking-tight font-medium text-[#1A1A1A] mt-3 leading-[1.1]">
          A note from the founder.
        </h2>

        {/* First-person letter, intimate but composed. Reads like an
            editor's note in a print magazine. */}
        <p className="font-heading italic text-xl lg:text-2xl text-stone-700 leading-[1.55] mt-8">
          For years, finding a stylist who truly understood your hair, your
          skin tone or your heritage meant trawling DMs, group chats and
          half-broken Instagram links. Stylists deserve a home that respects
          the craft. Clients deserve a way to find them without scrolling
          for an hour. I built Zuriya to be that home, an open directory for
          every heritage, every texture, every skin tone in the UK. If you
          cut, braid, lash, press, paint or glam, this is for you. If you
          book, this is for you too. Welcome in.
        </p>

        {/* Signature block: avatar, script signature, mono dateline.
            Mimics the pen-and-ink sign-off in print magazines. */}
        <div className="mt-12 flex items-center gap-5">
          {/* Founder headshot, /public/founders/majula.jpg */}
          <img
            src="/founders/majula.jpg"
            alt="Majula, founder of Zuriya"
            className="shrink-0 w-14 h-14 rounded-full object-cover border border-stone-300"
            data-testid="founder-avatar"
          />

          <div>
            <p
              className="font-signature text-5xl lg:text-6xl text-[#1A1A1A] leading-none -mb-1"
              data-testid="founder-signature"
            >
              Majula
            </p>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-stone-500 mt-3">
              Founder, Zuriya &middot; Sheffield &middot; Spring 2026
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
